import UsersList from './components/UsersList';

function App() {
  return <UsersList />;
}

export default App;
